
import React from "react";
import styles from './Main.module.css';
import SubMenu from "../../base/SubMenu";
import oberstufe from "./assets/oberstufe.png";

const Oberstufe = () => {
    return (
        <>
            <div
                className={styles.hero}
                style={{ backgroundImage: `url(${oberstufe})` }}
            >
                <div className={styles.heroBox}>
                 <h2 className={styles.heading}>GYMNASIALE OBERSTUFE</h2>
                 <h2 className={styles.subHeading}>HERZLICH WILLKOMMEN</h2>
                   <p>
                     Wir arbeiten derzeit <span style={{ fontWeight: 500 }}>intensiv am Aufbau</span> unserer gymnasialen Oberstufe.
                     Das <span style={{ fontWeight: 500 }}>Genehmigungsverfahren läuft bereits</span>.
                     <span style={{ fontWeight: 500 }}> Schon bald</span> finden Sie hier alle Informationen
                     zu unseren Kursen, Schwerpunkten und dem pädagogischen Konzept.
                   </p>


                </div>
            </div>
        </>
    );
};


function Main(props) {
    const part1Ref = React.createRef();
    const part2Ref = React.createRef();
    const part3Ref = React.createRef();
    const part4Ref = React.createRef();

    return (
        <React.Fragment>
            <SubMenu
                model={{
                    background: "#2dc653",
                    items: [
                        { label: <strong>Gymnasiale Oberstufe</strong>  },
                        /*
                        { label: "Start", onClick: () => window.location.href = "/bildungsangebote/igsoberstufe"},
                        { label: "Part1", onClick: () => part1Ref.current.scrollIntoView()},
                        { label: "Part2", onClick: () => part2Ref.current.scrollIntoView()},
                        { label: "Part3", onClick: () => part3Ref.current.scrollIntoView()},
                        { label: "Part4", onClick: () => part4Ref.current.scrollIntoView()}
                        */
                    ]
                }}
            />

            {/* Oberstufe burada çağrılıyor */}
            <Oberstufe />
{/*}
            <div ref={part1Ref} style={{ paddingTop: 'calc(var(--header-height) + 58px)' }}>1</div>
            <div ref={part2Ref} style={{ paddingTop: 'calc(var(--header-height) + 58px)' }}>2</div>
            <div ref={part3Ref} style={{ paddingTop: 'calc(var(--header-height) + 58px)' }}>3</div>
            <div ref={part4Ref} style={{ paddingTop: 'calc(var(--header-height) + 58px)' }}>4</div> */}
        </React.Fragment>
    );
}

export default Main;
